import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import {
    Drawer,
    Button,
    Space,
    Form,
    Row,
    Col,
    Input,
    Divider,
    Checkbox,
    InputNumber,
    message,
    Select,
    Card,
    Badge,
    Segmented,
    Spin
} from "antd";
import { useAtom } from "jotai";
import {
    visibleDrawerPropiedadesAtom,
    controlSeleccionadoAtom,
    componentesAtom,
    paginaPdfAtom,
    cargosAtom,
    sedesAtom,
    formulariosAtom,
    usuariosAtom,
} from "../../DisenarFormularioPdfStore";
import produce from "immer";
import { TipoControl, SignaturePerson } from "enums";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { SecurityContext } from "context/SecurityContextProvider";
import CargoService from "services/CargoService";
import SedeService from "services/SedeService";

import {
    AlignLeftOutlined,
    AlignCenterOutlined,
    AlignRightOutlined
} from "@ant-design/icons"
import UsuarioService from "services/UsuarioService";
// import { FormularioService } from "services/FormularioService";
import ColaboradorService from "services/ColaboradorService";
import { debounce } from "lodash";

const DrawerPropiedades = () => {
    const [paginaPdf] = useAtom(paginaPdfAtom);
    const [componentes, setComponentes] = useAtom(componentesAtom);
    const [visible, setVisible] = useAtom(visibleDrawerPropiedadesAtom);
    const [controlSeleccionado, setControlSeleccionado] = useAtom(controlSeleccionadoAtom);
    const [frmPropiedades] = Form.useForm();
    const [camposColaborador, setCamposColaborador] = useState(undefined);
    const [cargos, setCargos] = useAtom(cargosAtom);
    const [sedes, setSedes] = useAtom(sedesAtom);
    const [usuarios, setUsuarios] = useAtom(usuariosAtom);
    const [componenteCondicionalSeleccionado, setComponenteCondicionalSeleccionado] = useState(undefined);
    const [componenteAlertaSeleccionado, setComponenteAlertaSeleccionado] = useState(undefined);
    const [componenteValidacionLongitudSeleccionado, setComponenteValidacionLongitudSeleccionado] = useState(undefined);

    const defaultValue = Form.useWatch("defaultValue", frmPropiedades);
    const signaturePerson = Form.useWatch("signaturePerson", frmPropiedades);
    const tieneBloqueoSecuencial = Form.useWatch("tieneBloqueoSecuencial", frmPropiedades);
    const fuenteDatosListaTipo = Form.useWatch(["fuenteDatosLista", "tipo"], frmPropiedades);
    const tieneReglaPorDefecto = Form.useWatch("tieneReglaPorDefecto", frmPropiedades);
    // const [formularios, setFormularios] = useAtom(formulariosAtom);
    // const { Option } = Select;
    const { getUsuarioAutenticado } = useContext(SecurityContext);
    const [responsablesDesignados, setResponsablesDesignados] = useState([]);

    const [responsablesDesignadosListaInicial, setResponsablesDesignadosListaInicial] = useState([]);
    var opcionesResponsablesDesignados = [];

    const onClose = () => {
        setVisible(false);
    };

    const onClickBtnGuardar = () => {
        frmPropiedades
            .validateFields()
            .then((form) => {
                const existeControl = componentes.find((c) => c.key === form.key);
                if (existeControl && existeControl.key !== form.keyPrev) {
                    message.error("Ya existe un control con ese nombre");
                    return;
                }

                if (form.correlativo && componentes.some((c) => c.correlativo && c.key !== form.keyPrev)) {
                    message.error("Ya existe otro control correlativo en este formulario");
                    return;
                }

                setComponentes(
                    produce((draft) => {
                        //actualiza el control seleccionado
                        controlSeleccionado.ref.updateSize({
                            width: parseFloat(form.width),
                            height: parseFloat(form.height),
                        });
                        controlSeleccionado.ref.updatePosition({ x: parseFloat(form.left), y: parseFloat(form.top) });
                        setControlSeleccionado({ ...controlSeleccionado, key: form.key });
                        //actualiza control dentro del array de componentes
                        const controlEncontrado = draft.find((c) => c.key === form.keyPrev);
                        controlEncontrado.key = form.key;
                        controlEncontrado.label = form.label;
                        controlEncontrado.overlay.height = parseFloat(form.height);
                        controlEncontrado.overlay.width = parseFloat(form.width);
                        controlEncontrado.overlay.left = parseFloat(form.left);
                        controlEncontrado.overlay.top = parseFloat(form.top);
                        // controlEncontrado.overlay.topPdf = parseFloat(form.top);
                        controlEncontrado.required = form.required;
                        controlEncontrado.size = form.fuenteSize;

                        /* condicional */
                        if (form.accion !== undefined && form.control !== undefined && form.valor !== undefined) {
                            controlEncontrado.condicional = {
                                accion: form.accion,
                                control: form.control,
                                valor: form.valor,
                            };
                        }

                        /* alerta */
                        controlEncontrado.alerta = {
                            control: form.alertaControl,
                            valor: form.alertaValor,
                            correos: form.alertaCorreos ?? [],
                            mensaje: form.alertaMensaje ?? "",
                        };

                        /** Atributos para manejar el responsable del componente */
                        controlEncontrado.signaturePerson = form.signaturePerson;
                        controlEncontrado.cargo = form.cargo;
                        controlEncontrado.sede = form.sede;
                        controlEncontrado.usuarioId = form.usuarioId;
                        controlEncontrado.responsablesDesignadosIds = responsablesDesignados.map(item => item.value);

                        /** Formularios */
                        controlEncontrado.formularioId = form.formularioId;

                        if (controlEncontrado.type === TipoControl.CHECKBOX) {
                            controlEncontrado.value = form.value;
                            controlEncontrado.defaultValue = form.defaultValue;
                        }

                        if (controlEncontrado.type === TipoControl.IMAGEN) {
                            controlEncontrado.defaultValue = form.defaultValue;
                        }

                        if (controlEncontrado.type === TipoControl.RADIO_BUTTON) {
                            controlEncontrado.value = form.value;
                            controlEncontrado.name = form.name;
                            controlEncontrado.defaultValue = form.defaultValue;
                        }
                        if (controlEncontrado.type === TipoControl.CAJA_TEXTO
                            || controlEncontrado.type === TipoControl.ETIQUETA) {
                            controlEncontrado.defaultValue = form.defaultValue;
                            controlEncontrado.formatDefaultValue = form.formatDefaultValue;
                            controlEncontrado.readOnly = form.readOnly;
                            controlEncontrado.customDefaultValue = form.customDefaultValue;
                        }

                        if (controlEncontrado.type === TipoControl.LISTA) {
                            controlEncontrado.items = form.items;
                            controlEncontrado.fuenteDatosLista = form.fuenteDatosLista?.tipo
                                ? {
                                      tipo: form.fuenteDatosLista.tipo,
                                      control: form.fuenteDatosLista.control,
                                  }
                                : undefined;
                            controlEncontrado.defaultValue = form.fuenteDatosLista?.tipo ? form.defaultValue : undefined;
                        }

                        if (controlEncontrado.type === TipoControl.CAJA_TEXTO
                            || controlEncontrado.type === TipoControl.LISTA) {
                            controlEncontrado.campoBaseDatos = form.campoBaseDatos;
                        }

                        if (controlEncontrado.type === TipoControl.CAJA_TEXTO) {
                            controlEncontrado.maxLength = form.maxLength;
                            controlEncontrado.minLength = form.minLength;
                            controlEncontrado.pattern = form.pattern;
                            controlEncontrado.patternMessage = form.patternMessage;
                            controlEncontrado.grupoUnicidad = form.grupoUnicidad;
                            controlEncontrado.correlativo = form.correlativo ? true : undefined;
                            if (controlEncontrado.correlativo) {
                                controlEncontrado.required = false;
                            }
                            controlEncontrado.validacionLongitud = form.validacionLongitud?.control
                                ? {
                                      control: form.validacionLongitud.control,
                                      reglas: form.validacionLongitud.reglas ?? [],
                                      reglaPorDefecto: form.tieneReglaPorDefecto
                                          ? {
                                                requerido: form.validacionLongitud.reglaPorDefecto?.requerido,
                                                min: form.validacionLongitud.reglaPorDefecto?.min,
                                                max: form.validacionLongitud.reglaPorDefecto?.max,
                                            }
                                          : undefined,
                                      excepciones: form.validacionLongitud.excepciones ?? [],
                                  }
                                : undefined;
                        }

                        if (controlEncontrado.type === TipoControl.FECHA) {
                            controlEncontrado.restringirFechaActual = form.restringirFechaActual;
                            controlEncontrado.defaultValue = form.defaultValue;
                        }

                        // Bloqueo secuencial: disponible para cualquier tipo de campo (no solo Fecha),
                        // porque una "fila" de un registro diario puede incluir casillas de horario,
                        // firmas, etc. que también deben bloquearse junto con la fecha de esa fila.
                        if (controlEncontrado.type !== TipoControl.ETIQUETA && controlEncontrado.type !== TipoControl.FORMULA) {
                            controlEncontrado.grupoSecuencial = form.tieneBloqueoSecuencial ? form.grupoSecuencial : undefined;
                            controlEncontrado.ordenSecuencial = form.tieneBloqueoSecuencial ? form.ordenSecuencial : undefined;
                        }

                        if (controlEncontrado.type === TipoControl.SIGNATURE) {
                            controlEncontrado.signatureType = form.signatureType;
                            controlEncontrado.overlay.pageHeight = paginaPdf.alto;
                            console.log("overlay.pageHeight: ", paginaPdf.alto);
                            controlEncontrado.signatureInfo = form.signatureInfo;
                            controlEncontrado.requiereFirmaElectronica = form.requiereFirmaElectronica;
                            controlEncontrado.signatureOrder = form.signatureOrder;
                        }
                        // if (controlEncontrado.type === TipoControl.SIGNATURE_DATA) {
                        //   controlEncontrado.overlay.pageHeight = paginaPdf.alto;
                        // }

                        if (controlEncontrado.type === TipoControl.CAJA_TEXTO
                            || controlEncontrado.type === TipoControl.ETIQUETA
                            || controlEncontrado.type === TipoControl.LISTA) {
                            controlEncontrado.alineacionHorizontal = form.alineacionHorizontal;
                        }

                        if (form.table !== undefined && form.column !== undefined && form.rowNumber !== undefined) {
                            controlEncontrado.groupBy = {
                                table: form.table,
                                column: form.column,
                                rowNumber: form.rowNumber,
                            };
                        }

                        controlEncontrado.formula = form.formula;

                        frmPropiedades.setFieldsValue({ keyPrev: form.key });
                    })
                );
            })
            .catch((info) => {
                console.log("Validate Failed:", info);
            });
    };

    const onSelectControl = (key, item) => {
        const idControl = item.key.includes("|") ? item.key.split("|")[0] : item.key;
        const componente = componentes.find((componente) => componente.key === idControl);
        setComponenteCondicionalSeleccionado(componente);
    };

    const onSelectControlAlerta = (key, item) => {
        const idControl = item.key.includes("|") ? item.key.split("|")[0] : item.key;
        const componente = componentes.find((componente) => componente.key === idControl);
        setComponenteAlertaSeleccionado(componente);
    };

    const onSelectControlValidacionLongitud = (value) => {
        const componente = componentes.find((componente) => componente.key === value);
        setComponenteValidacionLongitudSeleccionado(componente);
    };

    useEffect(() => {
        const cargarDatos = async () => {
            if (visible) {
                const camposColaborador = getUsuarioAutenticado().empresaSeleccionada.camposColaborador;
                setCamposColaborador(camposColaborador);

                //if (controlSeleccionado.type === TipoControl.SIGNATURE) {
                const cargos = await CargoService.listar();
                setCargos(cargos);

                const sedes = await SedeService.listar();
                setSedes(sedes);

                const usuarios = await UsuarioService.listar();
                setUsuarios(usuarios);

                if (controlSeleccionado.responsablesDesignadosIds?.length > 0) {
                    for (const responsableDesignadoId of controlSeleccionado.responsablesDesignadosIds) {
                        const responsablesDesignado = await ColaboradorService.buscarPorId(responsableDesignadoId);
                        opcionesResponsablesDesignados.push({
                            label: responsablesDesignado.nombreCompleto,
                            value: responsablesDesignado.id,
                        });
                    }
                   // console.log("opcionesResponsablesDesignados", opcionesResponsablesDesignados);
                    setResponsablesDesignadosListaInicial(opcionesResponsablesDesignados);
                    setResponsablesDesignados(opcionesResponsablesDesignados); // IMPORTANTE: Setear el estado
                }

                frmPropiedades.setFieldsValue({
                    label: controlSeleccionado.label,
                    key: controlSeleccionado.key,
                    keyPrev: controlSeleccionado.key,
                    type: controlSeleccionado.type,
                    left: controlSeleccionado.overlay.left,
                    top: controlSeleccionado.overlay.top,
                    // topPdf: paginaPdf.alto - controlSeleccionado.overlay.top - controlSeleccionado.overlay.height,
                    width: controlSeleccionado.overlay.width,
                    height: controlSeleccionado.overlay.height,
                    accion: controlSeleccionado.condicional?.accion,
                    control: controlSeleccionado.condicional?.control,
                    valor: controlSeleccionado.condicional?.valor,
                    alertaControl: controlSeleccionado.alerta?.control,
                    alertaValor: controlSeleccionado.alerta?.valor,
                    alertaCorreos: controlSeleccionado.alerta?.correos ?? [],
                    alertaMensaje: controlSeleccionado.alerta?.mensaje,
                    required: controlSeleccionado.required,
                    table: controlSeleccionado.groupBy?.table,
                    column: controlSeleccionado.groupBy?.column,
                    rowNumber: controlSeleccionado.groupBy?.rowNumber,
                    value: controlSeleccionado.value,
                    name:
                        controlSeleccionado.groupBy && controlSeleccionado.name.includes("-")
                            ? controlSeleccionado.name.split("-")[1]
                            : controlSeleccionado.name,
                    defaultValue: controlSeleccionado.defaultValue,
                    formatDefaultValue: controlSeleccionado.formatDefaultValue,
                    customDefaultValue: controlSeleccionado.customDefaultValue,
                    readOnly: controlSeleccionado.readOnly,
                    items: controlSeleccionado.items,
                    fuenteDatosLista: controlSeleccionado.fuenteDatosLista,
                    signaturePerson: controlSeleccionado.signaturePerson,
                    cargo: controlSeleccionado.cargo,
                    responsablesDesignados: controlSeleccionado.responsablesDesignadosIds
					? controlSeleccionado.responsablesDesignadosIds
					: [],
                    sede: controlSeleccionado.sede,
                    usuarioId: controlSeleccionado.usuarioId,
                    signatureType: controlSeleccionado.signatureType,
                    signatureInfo: controlSeleccionado.signatureInfo,
                    requiereFirmaElectronica: controlSeleccionado.requiereFirmaElectronica,
                    formularioId: controlSeleccionado.formularioId,
                    fuenteSize: controlSeleccionado.size,
                    formula: controlSeleccionado.formula,
                    campoBaseDatos: controlSeleccionado.campoBaseDatos,
                    maxLength: controlSeleccionado.maxLength,
                    minLength: controlSeleccionado.minLength,
                    pattern: controlSeleccionado.pattern,
                    patternMessage: controlSeleccionado.patternMessage,
                    grupoUnicidad: controlSeleccionado.grupoUnicidad,
                    correlativo: controlSeleccionado.correlativo,
                    validacionLongitud: controlSeleccionado.validacionLongitud,
                    tieneReglaPorDefecto: !!controlSeleccionado.validacionLongitud?.reglaPorDefecto,
                    alineacionHorizontal: controlSeleccionado.alineacionHorizontal,
                    signatureOrder: controlSeleccionado.signatureOrder,
                    restringirFechaActual: controlSeleccionado.restringirFechaActual,
                    tieneBloqueoSecuencial: !!controlSeleccionado.grupoSecuencial,
                    grupoSecuencial: controlSeleccionado.grupoSecuencial,
                    ordenSecuencial: controlSeleccionado.ordenSecuencial
                });

                // Inicializar componenteAlertaSeleccionado para mostrar "Tenga el valor:" al cargar
                if (controlSeleccionado.alerta?.control) {
                    const alertaControlValue = controlSeleccionado.alerta.control;
                    const componenteAlerta =
                        componentes.find((c) => c.key === alertaControlValue) ||
                        componentes.find((c) => c.name === alertaControlValue && c.type === TipoControl.RADIO_BUTTON);
                    setComponenteAlertaSeleccionado(componenteAlerta);
                } else {
                    setComponenteAlertaSeleccionado(undefined);
                }

                // Inicializar componenteValidacionLongitudSeleccionado para poblar las opciones de "Valor" al cargar
                if (controlSeleccionado.validacionLongitud?.control) {
                    const componenteValidacionLongitud = componentes.find(
                        (c) => c.key === controlSeleccionado.validacionLongitud.control
                    );
                    setComponenteValidacionLongitudSeleccionado(componenteValidacionLongitud);
                } else {
                    setComponenteValidacionLongitudSeleccionado(undefined);
                }
            }
        };
        cargarDatos();
    }, [visible]);

    // useEffect(() => {
    //     const fetch = async () => {
    //         try {
    //             //setLoading(true);
    //             const formularios = await FormularioService.listarPorEmpresaId(
    //                 getUsuarioAutenticado().empresaSeleccionada.id
    //             );
    //             setFormularios(formularios);
    //         } catch (error) {
    //             console.error(error);
    //         } finally {
    //             //setLoading(false);
    //         }
    //     };
    //     fetch();
    // }, []);

    const generarOpcionesHijosEstudiosSuperiores = (cantidad) => {
        const opciones = [];
        for (let i = 1; i <= cantidad; i++) {
            opciones.push(
                {
                    value: `HIJO_ESTUDIO_SUPERIOR_${i}_DNI`,
                    label: `Hijo Estudio Superior ${i} - DNI`,
                },
                {
                    value: `HIJO_ESTUDIO_SUPERIOR_${i}_NOMBRES_APELLIDOS`,
                    label: `Hijo Estudio Superior ${i} - Nombres y Apellidos`,
                },
                {
                    value: `HIJO_ESTUDIO_SUPERIOR_${i}_FECHA_NACIMIENTO`,
                    label: `Hijo Estudio Superior ${i} - Fecha de Nacimiento`,
                },
                {
                    value: `HIJO_ESTUDIO_SUPERIOR_${i}_CENTRO_ESTUDIOS`,
                    label: `Hijo Estudio Superior ${i} - Centro Estudios`,
                },
                {
                    value: `HIJO_ESTUDIO_SUPERIOR_${i}_CARRERA`,
                    label: `Hijo Estudio Superior ${i} - Carrera`,
                },
                {
                    value: `HIJO_ESTUDIO_SUPERIOR_${i}_CICLO_SEMESTRE`,
                    label: `Hijo Estudio Superior ${i} - Ciclo / Semestre`,
                },
                {
                    value: `HIJO_ESTUDIO_SUPERIOR_${i}_SEXO`,
                    label: `Hijo Estudio Superior ${i} - Sexo`,
                }
            );
        }
        return opciones;
    };
    const generarOpcionesHijos = (cantidad) => {
        const opciones = [];
        for (let i = 1; i <= cantidad; i++) {
            opciones.push(
                {
                    value: `HIJO_MENOR_EDAD_${i}_DNI`,
                    label: `Hijo Menor edad ${i} - DNI`,
                },
                {
                    value: `HIJO_MENOR_EDAD_${i}_NOMBRES_APELLIDOS`,
                    label: `Hijo Menor edad ${i} - Nombres y Apellidos`,
                },
                {
                    value: `HIJO_MENOR_EDAD_${i}_FECHA_NACIMIENTO`,
                    label: `Hijo Menor edad ${i} - Fecha de Nacimiento`,
                },
                {
                    value: `HIJO_MENOR_EDAD_${i}_SEXO`,
                    label: `Hijo Menor edad ${i} - Sexo`,
                }
            );
        }
        return opciones;
    };

const OPCIONES_CAMPO_BASE_DATOS = [
    {
        label: 'Domicilio Colaborador',
        options: [
            {
                value: 'COLABORADOR_DOMICILIO_DIRECCION',
                label: 'Dirección',
            },
            {
                value: 'COLABORADOR_DOMICILIO_DEPARTAMENTO',
                label: 'Departamento',
            },
            {
                value: 'COLABORADOR_DOMICILIO_PROVINCIA',
                label: 'Provincia',
            },
            {
                value: 'COLABORADOR_DOMICILIO_DISTRITO',
                label: 'Distrito',
            },
        ],
    },
    {
        label: 'Información Contacto Colaborador',
        options: [
            {
                value: 'COLABORADOR_CELULAR',
                label: 'Celular',
            }
        ],
    },
    {
        label: 'Derecho Habientes - Hijos Menores Edad',
        options: generarOpcionesHijos(5),
    },
    {
        label: 'Derecho Habientes - Hijos Con estudios Superiores',
        options: generarOpcionesHijosEstudiosSuperiores(5),
    },
];

const fetchResponsablesDesignados = async (value) => {
    const respuesta = await ColaboradorService.listarPorNombreCompletoODni({
      filtro: value.trim(),
      login: getUsuarioAutenticado().login,
    });

    let colaboradores = respuesta.colaboradores || [];

    //solo los activos
    colaboradores = colaboradores.filter(c => c.estadoRegistro === "ACTIVO");

    //return respuesta.colaboradores.map((colaborador) => ({
    return colaboradores.map((colaborador) => ({
      label: colaborador.nombreCompleto,
      value: colaborador.id,
    }));

};

    return (
        <Drawer
            title="Propiedades Control"
            placement="right"
            onClose={onClose}
            open={visible}
            width="420px"
            extra={
                <Space>
                    <Button onClick={onClose}>Cerrar</Button>
                    <Button onClick={onClickBtnGuardar} type="primary">
                        Guardar
                    </Button>
                </Space>
            }
        >
            <Form layout="vertical" form={frmPropiedades}>
                <Form.Item name="keyPrev" hidden={true}>
                    <Input />
                </Form.Item>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="key"
                            label="Identificador"
                            rules={[{ required: true, message: "El campo identificador es requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="label"
                            label="Etiqueta"
                            rules={[{ required: true, message: "El campo etiqueta es requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="signaturePerson"
                            label={
                                controlSeleccionado?.type === TipoControl.SIGNATURE
                                    ? "¿Persona que firma?"
                                    : "Responsable"
                            }
                            rules={[
                                {
                                    required: controlSeleccionado?.type === TipoControl.SIGNATURE ? true : false,
                                    message: "Seleccione la persona que firma.",
                                },
                            ]}
                        >
                            <Select
                                style={{ width: "100%" }}
                                allowClear={controlSeleccionado?.type === TipoControl.SIGNATURE ? false : true}
                            >
                                <Select.Option value={SignaturePerson.COLABORADOR}>COLABORADOR</Select.Option>
                                <Select.Option value={SignaturePerson.NOTIFICADOR}>NOTIFICADOR</Select.Option>
                                <Select.Option value={SignaturePerson.JEFE_INMEDIATO}>JEFE INMEDIATO</Select.Option>
                                {/* <Select.Option value={SignaturePerson.JEFE_GESTION_HUMANA}>GESTIÓN HUMANA</Select.Option> */}
                                <Select.Option value={SignaturePerson.CARGO}>CARGO</Select.Option>
                                <Select.Option value={SignaturePerson.CARGO_Y_SEDE}>CARGO Y SEDE</Select.Option>
                                <Select.Option value={SignaturePerson.USUARIO_ADMINISTRADOR}>USUARIO ADMINISTRADOR</Select.Option>
                                <Select.Option value={SignaturePerson.RESPONSABLE_PERSONALIZADO}>PERSONALIZADO</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {(signaturePerson === SignaturePerson.CARGO || signaturePerson === SignaturePerson.CARGO_Y_SEDE) && (
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="cargo"
                                    label="Cargo"
                                    rules={[{ required: true, message: "Seleccione el cargo" }]}
                                >
                                    <Select
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        style={{ width: "100%" }}
                                    >
                                        {cargos &&
                                            cargos.map((cargo) => {
                                                return (
                                                    <Select.Option key={cargo.id} value={cargo.id}>
                                                        {cargo.nombre}
                                                    </Select.Option>
                                                );
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>               
                )}
                {signaturePerson === SignaturePerson.CARGO_Y_SEDE && (
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="sede"
                                label="Sede"
                                rules={[{ required: true, message: "Seleccione la sede" }]}
                            >
                                <Select style={{ width: "100%" }} showSearch>
                                    {sedes &&
                                        sedes.map((sede) => {
                                            return (
                                                <Select.Option key={sede.id} value={sede.id}>
                                                    {sede.nombre}
                                                </Select.Option>
                                            );
                                        })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                )}
                {signaturePerson === SignaturePerson.USUARIO_ADMINISTRADOR && (
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="usuarioId"
                                label="Usuario"
                                rules={[{ required: true, message: "Seleccione el usuario" }]}
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                    showSearch
                                    style={{ width: "100%" }}
                                >
                                    {usuarios &&
                                        usuarios.map((usuario) => {
                                            return (
                                                <Select.Option key={usuario.id} value={usuario.id}>
                                                    {usuario.nombreCompleto}
                                                </Select.Option>
                                            );
                                        })}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                )}

                {signaturePerson === SignaturePerson.RESPONSABLE_PERSONALIZADO && (
                    <Row>
                        <Col span={24}>
                            <Form.Item
                                label="Responsables designados"
                                name="responsablesDesignados"
                            >
                                <DebounceSelect
                                mode="multiple"
                                value={responsablesDesignados}
                                initialValues={responsablesDesignadosListaInicial}
                                placeholder="Selecciona a los responsables"
                                fetchOptions={fetchResponsablesDesignados}
                                onChange={(newValue) => {
                                    setResponsablesDesignados(newValue);
                                    frmPropiedades.setFieldValue('responsablesDesignados', newValue.map(v => v.value || v));
                                }}
                                style={{
                                    width: "100%",
                                }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                )}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.SIGNATURE && (
                    <React.Fragment>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="signatureType"
                                    label="Tipo Firma"
                                    initialValue={"IMAGEN_Y_DESCRIPCION"}
                                    rules={[{ required: true, message: "El campo tipo firma es requerido" }]}
                                >
                                    <Select style={{ width: "100%" }}>
                                        <Select.Option value="IMAGEN">IMAGEN</Select.Option>
                                        <Select.Option value="IMAGEN_Y_DESCRIPCION">IMAGEN Y DESCRIPCION</Select.Option>
                                        <Select.Option value="DESCRIPCION">DESCRIPCION</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="signatureInfo" label="Personalizar Descripción de Firma">
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="requiereFirmaElectronica" valuePropName="checked">
                                    <Checkbox>Requiere Firma Electrónica</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
                {controlSeleccionado && controlSeleccionado.type === TipoControl.RADIO_BUTTON && (
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="name"
                                label="Agrupar por"
                                rules={[{ required: true, message: "El campo nombre agrupamiento es requerido" }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                )}
                {controlSeleccionado &&
                    (controlSeleccionado.type === TipoControl.CHECKBOX ||
                        controlSeleccionado.type === TipoControl.RADIO_BUTTON) && (
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="value"
                                    label="Valor"
                                    rules={[{ required: true, message: "El campo valor es requerido" }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                <Divider orientation="left" plain>
                    Configuración
                </Divider>

                {controlSeleccionado && controlSeleccionado.type !== TipoControl.ETIQUETA &&
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item name="required" valuePropName="checked">
                                <Checkbox>Requerido</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                }

                {controlSeleccionado && controlSeleccionado.type === TipoControl.LISTA && (
                    <React.Fragment>
                        <Divider orientation="left" plain>
                            Fuente de Datos
                        </Divider>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name={["fuenteDatosLista", "tipo"]} label="Origen de las opciones">
                                    <Select style={{ width: "100%" }} allowClear>
                                        <Select.Option value="DEPARTAMENTO">DEPARTAMENTO / REGIÓN (Perú)</Select.Option>
                                        <Select.Option value="PROVINCIA">
                                            PROVINCIA (Perú, según Departamento)
                                        </Select.Option>
                                        <Select.Option value="DISTRITO">DISTRITO (Perú, según Provincia)</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        {(fuenteDatosListaTipo === "PROVINCIA" || fuenteDatosListaTipo === "DISTRITO") && (
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        name={["fuenteDatosLista", "control"]}
                                        label={
                                            fuenteDatosListaTipo === "PROVINCIA"
                                                ? "Control de Departamento:"
                                                : "Control de Provincia:"
                                        }
                                        rules={[{ required: true, message: "Seleccione el control del que depende" }]}
                                    >
                                        <Select style={{ width: "100%" }} showSearch allowClear>
                                            {componentes &&
                                                componentes
                                                    .filter(
                                                        (componente) =>
                                                            componente.type === TipoControl.LISTA &&
                                                            componente.key !== controlSeleccionado.key
                                                    )
                                                    .map((componente) => (
                                                        <Select.Option key={componente.key} value={componente.key}>
                                                            {componente.label} ({componente.key})
                                                        </Select.Option>
                                                    ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                        {fuenteDatosListaTipo && (
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name="defaultValue" label="Valor Inicial">
                                        <Select style={{ width: "100%" }} showSearch allowClear={true}>
                                            <Select.OptGroup label="DOMICILIO">
                                                <Select.Option value="${DEPARTAMENTO_DOMICILIO}">
                                                    DEPARTAMENTO (DOMICILIO)
                                                </Select.Option>
                                                <Select.Option value="${PROVINCIA_DOMICILIO}">
                                                    PROVINCIA (DOMICILIO)
                                                </Select.Option>
                                                <Select.Option value="${DISTRITO_DOMICILIO}">
                                                    DISTRITO (DOMICILIO)
                                                </Select.Option>
                                            </Select.OptGroup>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                    </React.Fragment>
                )}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.LISTA && !fuenteDatosListaTipo && (
                    <React.Fragment>
                        <Divider orientation="left" plain>
                            Valores Lista
                        </Divider>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.List name="items">
                                    {(fields, { add, remove }) => (
                                        <>
                                            {fields.map(({ key, name, ...restField }) => (
                                                <Space
                                                    key={key}
                                                    style={{ display: "flex", marginBottom: 8 }}
                                                    align="baseline"
                                                >
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, "key"]}
                                                        rules={[{ required: true, message: "Código es obligatorio" }]}
                                                    >
                                                        <Input placeholder="Código" />
                                                    </Form.Item>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, "value"]}
                                                        rules={[{ required: true, message: "Valor es obligatorio" }]}
                                                    >
                                                        <Input placeholder="Valor" />
                                                    </Form.Item>
                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                </Space>
                                            ))}
                                            <Form.Item>
                                                <Button
                                                    type="dashed"
                                                    onClick={() => add()}
                                                    block
                                                    icon={<PlusOutlined />}
                                                >
                                                    Adicionar Valores
                                                </Button>
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.CAJA_TEXTO
                    && (
                        <>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name="readOnly" valuePropName="checked">
                                        <Checkbox>Solo lectura</Checkbox>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )
                }

                {controlSeleccionado
                    && (controlSeleccionado.type === TipoControl.CAJA_TEXTO
                        || controlSeleccionado.type === TipoControl.ETIQUETA)
                    && (
                        <React.Fragment>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name="defaultValue" label="Valor Inicial">
                                        <Select style={{ width: "100%" }} showSearch allowClear={true}>
                                            <Select.Option value="${CODIGO}">CODIGO COLABORADOR</Select.Option>
                                            <Select.Option value="${DNI}">DNI</Select.Option>
                                            <Select.Option value="${DNI_NUMERO}">
                                                DNI {"(Mostrar si ocumento es DNI)"}
                                            </Select.Option>
                                            <Select.Option value="${CE_NUMERO}">
                                                CE {"(Mostrar si documento es CARNET DE EXTRANJERIA)"}
                                            </Select.Option>
                                            <Select.Option value="${APELLIDO_PATERNO}">APELLIDO PATERNO</Select.Option>
                                            <Select.Option value="${APELLIDO_MATERNO}">APELLIDO MATERNO</Select.Option>
                                            <Select.Option value="${NOMBRES}">NOMBRES</Select.Option>
                                            <Select.Option value="${NOMBRES_Y_APELLIDOS}">
                                                NOMBRES Y APELLIDOS
                                            </Select.Option>
                                            <Select.Option value="${CORREO_ELECTRONICO}">CORREO ELECTRÓNICO</Select.Option>
                                            <Select.Option value="${CELULAR}">CELULAR</Select.Option>
                                            <Select.Option value="${JEFE_INMEDIATO}">JEFE INMEDIATO</Select.Option>
                                            <Select.Option value="${PAIS_NACIMIENTO}">PAÍS NACIMIENTO</Select.Option>
                                            <Select.Option value="${NACIONALIDAD}">NACIONALIDAD</Select.Option>
                                            <Select.OptGroup label="DOMICILIO">
                                                <Select.Option value="${DIRECCION_DOMICILIO}">
                                                    DIRECCION (DOMICILIO)
                                                </Select.Option>
                                                <Select.Option value="${DEPARTAMENTO_DOMICILIO}">
                                                    DEPARTAMENTO (DOMICILIO)
                                                </Select.Option>
                                                <Select.Option value="${PROVINCIA_DOMICILIO}">
                                                    PROVINCIA (DOMICILIO)
                                                </Select.Option>
                                                <Select.Option value="${DISTRITO_DOMICILIO}">
                                                    DISTRITO (DOMICILIO)
                                                </Select.Option>
                                            </Select.OptGroup>
                                            <Select.Option value="${DIRECCION_NACIMIENTO}">
                                                DIRECCION NACIMIENTO
                                            </Select.Option>
                                            <Select.Option value="${DEPARTAMENTO_NACIMIENTO}">
                                                DEPARTAMENTO NACIMIENTO
                                            </Select.Option>
                                            <Select.Option value="${PROVINCIA_NACIMIENTO}">
                                                PROVINCIA NACIMIENTO
                                            </Select.Option>
                                            <Select.Option value="${DISTRITO_NACIMIENTO}">
                                                DISTRITO NACIMIENTO
                                            </Select.Option>
                                            <Select.Option value="${EDAD}">EDAD</Select.Option>
                                            <Select.Option value="${ESTADO_CIVIL}">ESTADO CIVIL</Select.Option>
                                            <Select.Option value="${CUSSP_AFP}">CUSPP AFP</Select.Option>
                                            <Select.Option value="${NOMBRE_AFP}">NOMBRE AFP</Select.Option>
                                            <Select.Option value="${FECHA_INGRESO}">FECHA DE INGRESO</Select.Option>
                                            <Select.Option value="${FECHA_NACIMIENTO}">FECHA NACIMIENTO</Select.Option>
                                            <Select.Option value="${FECHA_ACTUAL}">FECHA ACTUAL</Select.Option>
                                            {camposColaborador &&
                                                camposColaborador.length > 0 &&
                                                camposColaborador.map((campoColaborador) => {
                                                    return (
                                                        <Select.Option
                                                            key={campoColaborador.campo}
                                                            value={"${" + campoColaborador.campo + "}"}
                                                        >
                                                            {campoColaborador.etiqueta.toUpperCase()}
                                                        </Select.Option>
                                                    );
                                                })}

                                            <Select.Option value="${NOMBRES_Y_APELLIDOS_RESPONSABLE}">
                                                NOMBRES Y APELLIDOS (RESPONSABLE)
                                            </Select.Option>
                                            <Select.Option value="${CARGO_RESPONSABLE}">CARGO (RESPONSABLE)</Select.Option>

                                            <Select.Option value="${APELLIDOS_Y_NOMBRES}">APELLIDOS Y NOMBRES</Select.Option>
                                            <Select.Option value="${FECHA_ENVIO}">FECHA DE ENVÍO</Select.Option>

                                            <Select.OptGroup label="CUENTA BANCARIA HABERES">
                                                <Select.Option value="${BANCO_CTA_HABERES}">
                                                    BANCO (CTA. HABERES)
                                                </Select.Option>
                                                <Select.Option value="${NUMERO_CTA_HABERES}">
                                                    NÚMERO CUENTA (CTA. HABERES)
                                                </Select.Option>
                                                <Select.Option value="${NUMERO_CCI_CTA_HABERES}">
                                                    NÚMERO CUENTA CCI (CTA. HABERES)
                                                </Select.Option>
                                                <Select.Option value="${TIPO_MONEDA_CTA_HABERES}">
                                                    TIPO MONEDA (CTA. HABERES)
                                                </Select.Option>
                                            </Select.OptGroup>

                                            <Select.OptGroup label="CUENTA BANCARIA CTS">
                                                <Select.Option value="${BANCO_CTA_CTS}">BANCO (CTA. CTS)</Select.Option>
                                                <Select.Option value="${NUMERO_CTA_CTS}">
                                                    NÚMERO CUENTA (CTA. CTS)
                                                </Select.Option>
                                                <Select.Option value="${NUMERO_CCI_CTA_CTS}">
                                                    NÚMERO CUENTA CCI (CTA. CTS)
                                                </Select.Option>
                                                <Select.Option value="${TIPO_MONEDA_CTA_CTS}">
                                                    TIPO MONEDA (CTA. CTS)
                                                </Select.Option>
                                            </Select.OptGroup>

                                            <Select.OptGroup label="VACACIONES">
                                                <Select.Option value="${VACACIONES_DIAS_SOLICITADOS}">
                                                    DÍAS SOLICITADOS AUSENCIA
                                                </Select.Option>
                                                <Select.Option value="${VACACIONES_FECHA_INICIO}">
                                                    FECHA INICIO SOLICITUD AUSENCIA
                                                </Select.Option>
                                                <Select.Option value="${VACACIONES_FECHA_FIN}">
                                                    FECHA FIN SOLICITUD AUSENCIA
                                                </Select.Option>
                                                <Select.Option value="${VACACIONES_PERIODO_VACACIONAL_INICIO_FIN}">
                                                    PERIODO VACACIONAL
                                                </Select.Option>
                                            </Select.OptGroup>
                                            <Select.Option value="${PERSONALIZADO}">PERSONALIZADO</Select.Option>
                                        </Select>
                                    </Form.Item>

                                    {
                                        ("${FECHA_ACTUAL}".includes(defaultValue) ||
                                            "${FECHA_NACIMIENTO}".includes(defaultValue) ||
                                            "${FECHA_INGRESO}".includes(defaultValue)) && (
                                            <Form.Item name="formatDefaultValue" label="Personalizar">
                                                <Input />
                                            </Form.Item>
                                        )
                                    }

                                    {"${PERSONALIZADO}".includes(defaultValue)
                                        && controlSeleccionado.type === TipoControl.CAJA_TEXTO
                                        && (
                                            <Form.Item
                                                name="customDefaultValue"
                                                label="Personalizar"
                                                extra="Puede combinar texto y variables, ej.: Fecha envío: ${FECHA_ENVIO} · Colaborador: ${APELLIDOS_Y_NOMBRES}"
                                                rules={[{ required: true }]}
                                            >
                                                <Input />
                                            </Form.Item>
                                        )
                                    }

                                    {"${PERSONALIZADO}".includes(defaultValue)
                                        && controlSeleccionado.type === TipoControl.ETIQUETA
                                        && (
                                            <Form.Item
                                                name="customDefaultValue"
                                                label="Personalizar"
                                                extra="Puede combinar texto y variables, ej.: Fecha envío: ${FECHA_ENVIO} · Colaborador: ${APELLIDOS_Y_NOMBRES}"
                                                rules={[{ required: true }]}
                                            >
                                                <Input.TextArea />
                                            </Form.Item>
                                        )
                                    }

                                </Col>
                            </Row>
                        </React.Fragment>
                    )}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.CHECKBOX && (
                    <React.Fragment>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="defaultValue" label="Valor Inicial">
                                    <Select style={{ width: "100%" }} allowClear={true}>
                                        <Select.Option value="checked">SELECCIONADO</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.IMAGEN && (
                    <React.Fragment>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="defaultValue" label="Valor Inicial">
                                    <Select style={{ width: "100%" }} allowClear={true}>
                                        <Select.Option value="HUELLA_DACTILAR">HUELLA DACTILAR</Select.Option>
                                        <Select.Option value="FOTO">FOTO</Select.Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.FECHA && (
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item name="defaultValue" label="Valor Inicial">
                                <Select style={{ width: "100%" }} allowClear={true}>
                                    <Select.Option value="${FECHA_NACIMIENTO}">FECHA NACIMIENTO</Select.Option>
                                    <Select.Option value="${FECHA_INGRESO}">FECHA DE INGRESO</Select.Option>
                                    <Select.Option value="${FECHA_ACTUAL}">FECHA ACTUAL</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="restringirFechaActual" valuePropName="checked">
                                <Checkbox>
                                    <span style={{ display: "block" }}>Restringir a la fecha actual</span>
                                    <span style={{ color: "gray" }}>
                                        El colaborador solo puede seleccionar el día de hoy, no fechas pasadas ni futuras.
                                    </span>
                                </Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                )}

                {controlSeleccionado
                    && controlSeleccionado.type !== TipoControl.ETIQUETA
                    && controlSeleccionado.type !== TipoControl.FORMULA
                    && (
                    <React.Fragment>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="tieneBloqueoSecuencial" valuePropName="checked">
                                    <Checkbox>
                                        <span style={{ display: "block" }}>Bloqueo secuencial (una fila a la vez)</span>
                                        <span style={{ color: "gray" }}>
                                            Para formularios de registro diario: agrupa este campo con el campo Fecha de su misma fila (mismo "Grupo de secuencia" y "Orden"). Solo la fila que corresponde queda editable, empezando por la primera; las anteriores quedan de solo lectura y las siguientes deshabilitadas hasta que llegue su turno.
                                        </span>
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                        {tieneBloqueoSecuencial && (
                            <Row gutter={16}>
                                <Col span={16}>
                                    <Form.Item
                                        name="grupoSecuencial"
                                        label="Grupo de secuencia"
                                        rules={[{ required: true, message: "El grupo de secuencia es obligatorio." }]}
                                    >
                                        <Input placeholder="ej. registro-diario" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        name="ordenSecuencial"
                                        label="Orden (fila)"
                                        rules={[{ required: true, message: "El orden es obligatorio." }]}
                                    >
                                        <InputNumber min={1} style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                    </React.Fragment>
                )}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.RADIO_BUTTON && (
                    <React.Fragment>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="defaultValue" label="Valor Inicial">
                                    <Select style={{ width: "100%" }} allowClear={true}>
                                        <Select.Option value="${GENERO}">GENERO</Select.Option>
                                        <Select.Option value="${ESTADO_CIVIL}">ESTADO CIVIL</Select.Option>
                                        <Select.Option value="${TIPO_TRABAJADOR}">TIPO TRABAJADOR</Select.Option>
                                        <Select.Option value="${REGIMEN_PENSIONARIO}">
                                            RÉGIMEN PENSIONARIO
                                        </Select.Option>
                                        {camposColaborador &&
                                            camposColaborador.length > 0 &&
                                            camposColaborador.map((campoColaborador) => {
                                                return (
                                                    <Select.Option
                                                        key={campoColaborador.campo}
                                                        value={"${" + campoColaborador.campo + "}"}
                                                    >
                                                        {campoColaborador.etiqueta.toUpperCase()}
                                                    </Select.Option>
                                                );
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </React.Fragment>
                )}

                <Divider orientation="left" plain>
                    Posición y Tamaño
                </Divider>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="left"
                            label="Izquierda"
                            rules={[{ required: true, message: "El campo izquierda es requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="top"
                            label="Arriba"
                            rules={[{ required: true, message: "El campo alto es requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    {/* <Col span={12}>
            <Form.Item
              name="topPdf"
              label="Arriba PDF"
              rules={[{ required: true, message: "El campo alto es requerido" }]}
            >
              <Input />
            </Form.Item>
          </Col> */}
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="width"
                            label="Ancho"
                            rules={[{ required: true, message: "El campo ancho es requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="height"
                            label="Alto"
                            rules={[{ required: true, message: "El campo altura es requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                {controlSeleccionado
                    && controlSeleccionado.type !== TipoControl.FORMULA
                    && controlSeleccionado.type !== TipoControl.SIGNATURE
                    && controlSeleccionado.type !== TipoControl.IMAGEN
                    && (
                        <React.Fragment>
                            <Divider orientation="left" plain>
                                Agrupar
                            </Divider>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item name="table" label="Nombre Tabla">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="column" label="Nombre Columna">
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item name="rowNumber" label="Número Fila">
                                        <InputNumber min={1} max={20} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}

                <Divider orientation="left" plain>
                    Fuente
                </Divider>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item name="fuenteSize" label="Tamaño">
                            <InputNumber min={1} max={20} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item name="alineacionHorizontal" label="Horizontal">
                            <Segmented
                                options={[
                                    {
                                        value: 'IZQUIERDA',
                                        icon: <AlignLeftOutlined />,
                                    },
                                    {
                                        value: 'CENTRO',
                                        icon: <AlignCenterOutlined />,
                                    },
                                    {
                                        value: 'DERECHA',
                                        icon: <AlignRightOutlined />,
                                    },
                                ]}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                {controlSeleccionado && controlSeleccionado.type === TipoControl.SIGNATURE
                    && (
                        <>
                            <Divider orientation="left" plain>
                                Flujo de Firmas
                            </Divider>

                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        name="signatureOrder"
                                        label="Orden Firma"
                                    >
                                        <InputNumber min={1} max={50} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )
                }

                {controlSeleccionado && controlSeleccionado.type === TipoControl.CAJA_TEXTO
                    && (
                        <>
                            <Divider orientation="left" plain>
                                Longitud
                            </Divider>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item name="minLength" label="Mínima">
                                        <InputNumber min={1} max={100} style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name="maxLength" label="Máxima">
                                        <InputNumber min={1} max={100} style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>)}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.CAJA_TEXTO
                    && (
                        <>
                            <Divider orientation="left" plain>
                                Formato (Expresión Regular)
                            </Divider>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        name="pattern"
                                        label="Patrón"
                                        extra={
                                            <span style={{ color: "gray", fontSize: "12px" }}>
                                                Ej. fecha dd/MM/yyyy: ^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\d{4}$
                                            </span>
                                        }
                                    >
                                        <Input placeholder="Expresión regular (opcional)" />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name="patternMessage" label="Mensaje de error">
                                        <Input placeholder="Mensaje a mostrar si no cumple el patrón" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>)}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.CAJA_TEXTO
                    && (
                        <>
                            <Divider orientation="left" plain>
                                Correlativo
                            </Divider>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name="correlativo" valuePropName="checked">
                                        <Checkbox>
                                            <span style={{ display: "block" }}>Número correlativo automático</span>
                                            <span style={{ color: "gray" }}>
                                                Al firmar, el sistema asigna un número único y consecutivo (por formulario
                                                y empresa, ej. 000000123) y lo coloca en este campo. El colaborador no puede
                                                editarlo. Solo se permite un campo correlativo por formulario.
                                            </span>
                                        </Checkbox>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Divider orientation="left" plain>
                                Unicidad
                            </Divider>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        name="grupoUnicidad"
                                        label="Grupo de unicidad"
                                        extra={
                                            <span style={{ color: "gray", fontSize: "12px" }}>
                                                Controles con el mismo valor de grupo no podrán repetir su valor entre sí
                                                (ej. "DNI_HIJOS" en todos los DNI de hijos para evitar duplicados).
                                            </span>
                                        }
                                    >
                                        <Input placeholder="Ej. DNI_HIJOS (dejar vacío para no validar)" />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>)}

                {controlSeleccionado && controlSeleccionado.type === TipoControl.CAJA_TEXTO
                    && (
                        <>
                            <Divider orientation="left" style={{ fontWeight: "bold" }}>
                                Validación de Longitud por Valor
                            </Divider>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item
                                        name={["validacionLongitud", "control"]}
                                        label="Validar cantidad de dígitos según el valor de:"
                                    >
                                        <Select
                                            style={{ width: "100%" }}
                                            showSearch
                                            allowClear
                                            onSelect={onSelectControlValidacionLongitud}
                                            onClear={() => setComponenteValidacionLongitudSeleccionado(undefined)}
                                        >
                                            {componentes &&
                                                componentes
                                                    .filter((componente) => componente.type === TipoControl.LISTA)
                                                    .map((componente) => (
                                                        <Select.Option key={componente.key} value={componente.key}>
                                                            {componente.label} ({componente.key})
                                                        </Select.Option>
                                                    ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            {componenteValidacionLongitudSeleccionado && (
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.List name={["validacionLongitud", "reglas"]}>
                                            {(fields, { add, remove }) => (
                                                <>
                                                    {fields.map(({ key, name, ...restField }) => (
                                                        <Space
                                                            key={key}
                                                            style={{ display: "flex", marginBottom: 8 }}
                                                            align="baseline"
                                                        >
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "valor"]}
                                                                rules={[{ required: true, message: "Requerido" }]}
                                                            >
                                                                <Select
                                                                    placeholder="Valor"
                                                                    style={{ width: 150 }}
                                                                    showSearch
                                                                    filterOption={(input, option) =>
                                                                        option.children
                                                                            .toLowerCase()
                                                                            .includes(input.toLowerCase())
                                                                    }
                                                                >
                                                                    {componenteValidacionLongitudSeleccionado.items?.map(
                                                                        (item) => (
                                                                            <Select.Option key={item.key} value={item.key}>
                                                                                {item.value}
                                                                            </Select.Option>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            </Form.Item>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "min"]}
                                                                rules={[{ required: true, message: "Requerido" }]}
                                                            >
                                                                <InputNumber min={1} max={100} placeholder="Mín. dígitos" />
                                                            </Form.Item>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "max"]}
                                                                rules={[{ required: true, message: "Requerido" }]}
                                                            >
                                                                <InputNumber min={1} max={100} placeholder="Máx. dígitos" />
                                                            </Form.Item>
                                                            <Form.Item
                                                                {...restField}
                                                                name={[name, "requerido"]}
                                                                valuePropName="checked"
                                                            >
                                                                <Checkbox>Obligatorio</Checkbox>
                                                            </Form.Item>
                                                            <MinusCircleOutlined onClick={() => remove(name)} />
                                                        </Space>
                                                    ))}
                                                    <Form.Item>
                                                        <Button
                                                            type="dashed"
                                                            onClick={() => add()}
                                                            block
                                                            icon={<PlusOutlined />}
                                                        >
                                                            Adicionar Regla
                                                        </Button>
                                                    </Form.Item>
                                                </>
                                            )}
                                        </Form.List>
                                        <div style={{ color: "gray", fontSize: "12px", marginTop: "-8px" }}>
                                            Los valores sin regla propia se evalúan contra la Regla por Defecto (si está activada).
                                        </div>
                                    </Col>
                                </Row>
                            )}
                            {componenteValidacionLongitudSeleccionado && (
                                <>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Form.Item name="tieneReglaPorDefecto" valuePropName="checked" style={{ marginBottom: 8 }}>
                                                <Checkbox>
                                                    <span style={{ display: "block" }}>Aplicar regla por defecto a los demás valores</span>
                                                    <span style={{ color: "gray" }}>
                                                        Se aplica a cualquier valor que no tenga una regla propia ni esté en las excepciones
                                                        (ej. exigir 20 dígitos obligatorios para "todos los demás bancos").
                                                    </span>
                                                </Checkbox>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    {tieneReglaPorDefecto && (
                                        <Row gutter={16} align="middle">
                                            <Col span={8}>
                                                <Form.Item
                                                    name={["validacionLongitud", "reglaPorDefecto", "min"]}
                                                    rules={[{ required: true, message: "Requerido" }]}
                                                >
                                                    <InputNumber min={1} max={100} placeholder="Mín. dígitos" style={{ width: "100%" }} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    name={["validacionLongitud", "reglaPorDefecto", "max"]}
                                                    rules={[{ required: true, message: "Requerido" }]}
                                                >
                                                    <InputNumber min={1} max={100} placeholder="Máx. dígitos" style={{ width: "100%" }} />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item
                                                    name={["validacionLongitud", "reglaPorDefecto", "requerido"]}
                                                    valuePropName="checked"
                                                >
                                                    <Checkbox>Obligatorio</Checkbox>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    )}
                                    {tieneReglaPorDefecto && (
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div style={{ marginBottom: 4 }}>Excepciones (sin restricción):</div>
                                                <Form.List name={["validacionLongitud", "excepciones"]}>
                                                    {(fields, { add, remove }) => (
                                                        <>
                                                            {fields.map(({ key, name, ...restField }) => (
                                                                <Space
                                                                    key={key}
                                                                    style={{ display: "flex", marginBottom: 8 }}
                                                                    align="baseline"
                                                                >
                                                                    <Form.Item
                                                                        {...restField}
                                                                        name={[name]}
                                                                        rules={[{ required: true, message: "Requerido" }]}
                                                                    >
                                                                        <Select
                                                                            placeholder="Valor"
                                                                            style={{ width: 220 }}
                                                                            showSearch
                                                                            filterOption={(input, option) =>
                                                                                option.children
                                                                                    .toLowerCase()
                                                                                    .includes(input.toLowerCase())
                                                                            }
                                                                        >
                                                                            {componenteValidacionLongitudSeleccionado.items?.map(
                                                                                (item) => (
                                                                                    <Select.Option key={item.key} value={item.key}>
                                                                                        {item.value}
                                                                                    </Select.Option>
                                                                                )
                                                                            )}
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                                </Space>
                                                            ))}
                                                            <Form.Item>
                                                                <Button
                                                                    type="dashed"
                                                                    onClick={() => add()}
                                                                    block
                                                                    icon={<PlusOutlined />}
                                                                >
                                                                    Adicionar Excepción
                                                                </Button>
                                                            </Form.Item>
                                                        </>
                                                    )}
                                                </Form.List>
                                            </Col>
                                        </Row>
                                    )}
                                </>
                            )}
                        </>
                    )}

                <Divider orientation="left" style={{ fontWeight: "bold" }}>
                    Condicional
                </Divider>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="accion" label="Este control debe:">
                            <Select style={{ width: "100%" }} allowClear={true}>
                                <Select.Option value="show">MOSTRARSE</Select.Option>
                                <Select.Option value="hidden">OCULTARSE</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="control" label="Cuando el siguiente control:">
                            <Select style={{ width: "100%" }} showSearch allowClear={true} onSelect={onSelectControl}>
                                {componentes &&
                                    componentes
                                        .filter((componente) => componente.type === TipoControl.CHECKBOX)
                                        .map((componente) => {
                                            return (
                                                <Select.Option key={componente.key} value={componente.key}>
                                                    {componente.label} ({componente.key})
                                                </Select.Option>
                                            );
                                        })}
                                {componentes &&
                                    componentes
                                        .filter((componente) => componente.type === TipoControl.RADIO_BUTTON)
                                        .filter(
                                            (componente, index, arr) =>
                                                arr.findIndex((e) => e.name === componente.name) === index
                                        )
                                        .map((componente) => {
                                            return (
                                                <Select.Option
                                                    key={componente.key + "|" + componente.name}
                                                    value={componente.name}
                                                >
                                                    {componente.name} ({"radiobutton"})
                                                </Select.Option>
                                            );
                                        })}
                                {componentes &&
                                    componentes
                                        .filter((componente) => componente.type === TipoControl.LISTA)
                                        .map((componente) => {
                                            return (
                                                <Select.Option key={componente.key} value={componente.key}>
                                                    {componente.label} ({componente.key})
                                                </Select.Option>
                                            );
                                        })}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        {componenteCondicionalSeleccionado?.type === "checkbox" && (
                            <Form.Item name="valor" label="Tenga el valor:">
                                <Select style={{ width: "100%" }} allowClear={true}>
                                    <Select.Option value="checked">SELECCIONADO</Select.Option>
                                </Select>
                            </Form.Item>
                        )}
                        {componenteCondicionalSeleccionado?.type === "radiobutton" && (
                            <Form.Item name="valor" label="Tenga el valor:">
                                <Input />
                            </Form.Item>
                        )}
                        {componenteCondicionalSeleccionado?.type === TipoControl.LISTA && (
                            <Form.Item name="valor" label="Tenga el valor:">
                                <Input.TextArea />
                            </Form.Item>
                        )}
                    </Col>
                </Row>

                <Divider orientation="left" style={{ fontWeight: "bold" }}>
                    Fórmula
                </Divider>

                {controlSeleccionado
                    && controlSeleccionado.type === TipoControl.FORMULA
                    && (
                        <>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name={["formula", "accion"]} label="Acción">
                                        <Select style={{ width: "100%" }} allowClear={true}>
                                            <Select.Option value="SUMAR">SUMAR</Select.Option>
                                            <Select.Option value="TEXTO_CONDICIONAL">TEXTO CONDICIONAL</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name={["formula", "controles"]} label="Controles">
                                        <Select mode="multiple" showSearch allowClear={true} style={{ width: "100%" }}>
                                            {componentes &&
                                                componentes
                                                    .filter((componente) => componente.type === TipoControl.RADIO_BUTTON)
                                                    .filter(
                                                        (componente, index, arr) =>
                                                            arr.findIndex((e) => e.name === componente.name) === index
                                                    )
                                                    .map((componente) => {
                                                        return (
                                                            <Select.Option
                                                                key={componente.key + "|" + componente.name}
                                                                value={componente.name}
                                                            >
                                                                {componente.name} ({"radiobutton"})
                                                            </Select.Option>
                                                        );
                                                    })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name={["formula", "logica"]} label="Lógica">
                                        <Input.TextArea rows={4} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )
                }

                {controlSeleccionado
                    && controlSeleccionado.type !== TipoControl.FORMULA
                    && (
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name={["formula", "valor"]} label="Valor">
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                    )
                }

                {controlSeleccionado
                    && (controlSeleccionado.type === TipoControl.CAJA_TEXTO
                        || controlSeleccionado.type === TipoControl.LISTA)
                    && (
                        <>
                            <Divider orientation="left" style={{ fontWeight: "bold" }}>
                                Guardar en campo
                            </Divider>

                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name="campoBaseDatos">
                                        <Select
                                            style={{
                                                display: 'block'
                                            }}
                                            // options={[
                                            //     {
                                            //         label: 'Domicilio Colaborador',
                                            //         options: [
                                            //             {
                                            //                 value: 'COLABORADOR_DOMICILIO_DIRECCION',
                                            //                 label: 'Dirección',
                                            //             },
                                            //             {
                                            //                 value: 'COLABORADOR_DOMICILIO_DEPARTAMENTO',
                                            //                 label: 'Departamento',
                                            //             },
                                            //             {
                                            //                 value: 'COLABORADOR_DOMICILIO_PROVINCIA',
                                            //                 label: 'Provincia',
                                            //             },
                                            //             {
                                            //                 value: 'COLABORADOR_DOMICILIO_DISTRITO',
                                            //                 label: 'Distrito',
                                            //             },
                                            //         ],
                                            //     },
                                            //     {
                                            //         label: 'Información Contacto Colaborador',
                                            //         options: [
                                            //             {
                                            //                 value: 'COLABORADOR_CELULAR',
                                            //                 label: 'Celular',
                                            //             }
                                            //         ],
                                            //     },
                                            //     {
                                            //         label: 'Derecho Habientes',
                                            //         options: [
                                            //             {
                                            //                 value: 'HIJO1_DNI',
                                            //                 label: 'Hijo1 DNI',
                                            //             },
                                            //             {
                                            //                 value: 'HIJO1_NOMBRES_APELLIDOS',
                                            //                 label: 'Hijo1 Nombre y Apellidos',
                                            //             },
                                            //             {
                                            //                 value: 'HIJO1_FECHA_NACIMIENTO',
                                            //                 label: 'Hijo1 Fecha Nacimiento',
                                            //             },
                                            //             {
                                            //                 value: 'HIJO2_DNI',
                                            //                 label: 'Hijo2 DNI',
                                            //             },
                                            //             {
                                            //                 value: 'HIJO2_NOMBRES_APELLIDOS',
                                            //                 label: 'Hijo2 Nombre y Apellidos',
                                            //             },
                                            //             {
                                            //                 value: 'HIJO2_FECHA_NACIMIENTO',
                                            //                 label: 'Hijo2 Fecha Nacimiento',
                                            //             },
                                            //         ],
                                            //     },
                                            // ]} 
                                            options={OPCIONES_CAMPO_BASE_DATOS}
                                            />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )}



                <Divider orientation="left" style={{ fontWeight: "bold" }}>
                    Alerta
                </Divider>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="alertaControl" label="Cuando el siguiente control:">
                            <Select style={{ width: "100%" }} showSearch allowClear={true} onSelect={onSelectControlAlerta}>
                                {componentes &&
                                    componentes
                                        .filter((componente) => componente.type === TipoControl.CHECKBOX)
                                        .map((componente) => (
                                            <Select.Option key={componente.key} value={componente.key}>
                                                {componente.label} ({componente.key})
                                            </Select.Option>
                                        ))}
                                {componentes &&
                                    componentes
                                        .filter((componente) => componente.type === TipoControl.RADIO_BUTTON)
                                        .filter(
                                            (componente, index, arr) =>
                                                arr.findIndex((e) => e.name === componente.name) === index
                                        )
                                        .map((componente) => (
                                            <Select.Option
                                                key={componente.key + "|" + componente.name}
                                                value={componente.name}
                                            >
                                                {componente.name} ({"radiobutton"})
                                            </Select.Option>
                                        ))}
                                {componentes &&
                                    componentes
                                        .filter((componente) => componente.type === TipoControl.LISTA)
                                        .map((componente) => (
                                            <Select.Option key={componente.key} value={componente.key}>
                                                {componente.label} ({componente.key})
                                            </Select.Option>
                                        ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        {componenteAlertaSeleccionado?.type === "checkbox" && (
                            <Form.Item name="alertaValor" label="Tenga el valor:">
                                <Select style={{ width: "100%" }} allowClear={true}>
                                    <Select.Option value="checked">SELECCIONADO</Select.Option>
                                </Select>
                            </Form.Item>
                        )}
                        {componenteAlertaSeleccionado?.type === "radiobutton" && (
                            <Form.Item name="alertaValor" label="Tenga el valor:">
                                <Input />
                            </Form.Item>
                        )}
                        {componenteAlertaSeleccionado?.type === TipoControl.LISTA && (
                            <Form.Item name="alertaValor" label="Tenga el valor:">
                                <Input.TextArea />
                            </Form.Item>
                        )}
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="alertaCorreos" label="Correos electrónicos:">
                            <Select
                                mode="tags"
                                style={{ width: "100%" }}
                                placeholder="Escriba un correo y presione Enter"
                                tokenSeparators={[","]}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="alertaMensaje" label="Mensaje personalizado:">
                            <Input.TextArea rows={3} placeholder="Escriba el mensaje de alerta..." />
                        </Form.Item>
                    </Col>
                </Row>

                {/* <Divider orientation="left" style={{ fontWeight: "bold" }}>
                    ONBOARDING
                </Divider>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="formularioId" label="Seleccionar Formulario:">
                            <Select
                                style={{ width: "100%" }}
                                showSearch
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                allowClear={true}
                            >
                                {formularios.length > 0 &&
                                    formularios.map((lista) => {
                                        return (
                                            <Option key={lista.id} value={lista.id}>
                                                {lista.nombre}
                                            </Option>
                                        );
                                    })}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row> */}
            </Form>
        </Drawer >
    );
};

export default DrawerPropiedades;

const DebounceSelect = ({ fetchOptions, initialValues = [], debounceTimeout = 800, ...props }) => {
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const fetchRef = useRef(0);

    useEffect(() => {
        setOptions(initialValues);
    }, [initialValues]);

    const debounceFetcher = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);
            fetchOptions(value).then((newOptions) => {
                if (fetchId !== fetchRef.current) {
                    // for fetch callback order
                    return;
                }
                setOptions(newOptions);
                setFetching(false);
            });
        };
        return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout]);

    return (
        <Select
            labelInValue
            filterOption={false}
            onSearch={debounceFetcher}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            options={options}
            {...props}
        />
    );
}